/**
 * Swiper dependencies
 *
 * @see https://swiperjs.com/get-started
 */
import { Swiper } from 'swiper';
import {
  Autoplay,
  Keyboard,
  Navigation,
  Pagination,
  EffectFade,
} from 'swiper/modules';

/**
 * Initialize the slider.
 *
 * @param {Element} container HTMLElement.
 * @param {Object}  options   Slider parameters.
 *
 * @return {Object} Returns initialized slider instance.
 *
 * @see https://swiperjs.com/swiper-api#parameters
 */
export function SwiperInit(container, options = {}) {
  const parameters = {
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: { crossFade: true },
    centeredSlides: options?.centerSlides ?? false,
    autoplay: options?.autoplay ?? false,
    grabCursor: options?.grabCursor ?? true,
    initialSlide: 0,
    keyboard: true,
    speed: 1,
    modules: [Autoplay, Keyboard, Navigation, Pagination, EffectFade],
    navigation: {
      nextEl: '.swiper-button-next4',
      prevEl: '.swiper-button-prev4',
    },
    pagination: { enabled: options?.pagination ?? false, clickable: true },
    simulateTouch: options?.simulateTouch ?? true,
  };

  return new Swiper(container, parameters);
}
